// For deploying staging environment on Cloudflare
const THREEKIT_AUTH_TOKEN = '73e5a97e-0378-45b1-b9fd-ee4f985f8c72';
const THREEKIT_HOST = 'https://admin-fts.threekit.com';
const THREEKIT_ORG = 'af6348d6-d6b0-4c7a-84dd-cc698acf4f50';
const USE_PLAYER_CACHING = false;

export { THREEKIT_HOST, THREEKIT_ORG, THREEKIT_AUTH_TOKEN, USE_PLAYER_CACHING };
